import React, {useContext, useState} from "react";
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import Button from "../Button";
import "cropperjs/dist/cropper.css";
import Switch from "react-switch";
import imageCompression from "browser-image-compression";
import {fileToBase64} from "../../tools/helpers";
import CropperModal from "./CropperModal";
import Api from "../../tools/service";
import ErrorModal from "./ErrorModal";
import REQUEST_URLS from "../../tools/defaults/requestUrl";


const EditAuthWidgetModal = (props) => {

    const [showName, setShowName] = useState("name_visible" in props.widget?.widget_settings ? !!props.widget?.widget_settings?.name_visible : true)
    const [showImage, setShowImage] = useState("pic_visible" in props.widget?.widget_settings ? !!props.widget?.widget_settings?.pic_visible : true);
    const [changedImage, setChangedImage] = useState(null)
    const [loading, setLoading] = useState(false)
    const handleConfirm = () => {
        console.log({
            pid: props.widget.pid,
            //name_visible: showName,
            name_visible: true,
            pic_visible: showImage,
            update_pic: changedImage ? changedImage.replace('data:image/png;base64,', '') : null,
        })
        setLoading(true);
        Api.post(REQUEST_URLS.AUTHENTICATION.MANAGE_I_AUTH, {
            pid: props.widget.pid,
            name_visible: showName,
            pic_visible: showImage,
            update_pic: changedImage ? changedImage.replace('data:image/png;base64,', '') : null,
        }, {
            headers: {
                "Authorization": `Bearer ${props.token}`
            },
        }).then(response => {
            if (response.hasError) {
                Reoverlay.showModal(ErrorModal, {
                    title: 'خطا',
                    message: response.message,
                    showCancelButton: true,
                    onCancel: () => {

                    }
                });

            } else {
                Reoverlay.hideModal();
                props.handleInquiryProcess()


            }

        }).catch(e => {

        }).finally(() => {
            setLoading(false)
        })
    }
    const handleChooseFile = (e) => {
        const options = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
        }

        imageCompression(e.target.files[0], options).then(compressedFile => {

            fileToBase64(compressedFile).then(base64 => {
                Reoverlay.showModal(CropperModal, {
                    name: 'برش تصویر',
                    canClose: true,
                    description: '',
                    onConfirm: (image) => {
                        setChangedImage(image)
                        Reoverlay.hideModal()
                    },
                    image: base64
                })


            })
        }).catch(e => {
            console.log(e)
        }).finally(() => {

        })
    }
    const handleCloseModal = () => {
        Reoverlay.hideModal()
    }

    return <ModalWrapper onClose={() => {
    }} animation="slideDown" contentContainerClassName="w-11/12 md:8/12 lg:w-4/12 p-5 rounded-xl">

        <div className="modal-content">
            <h1 className="text-center  font-bold text-xl  mb-1  border-gray-100">{props.name}</h1>
            <h1 className="text-center  font-bold text-sm pb-5 mb-5 border-b-2 border-gray-100">{props.description}</h1>
            <div className="flex justify-between items-end rounded-lg relative  mb-3 ">

                <div className="flex justify-start">
                    <img className="w-20 h-auto rounded-lg"
                         src={changedImage ? changedImage : showImage ? ("data:image/png;base64," + props.widget.widgets_body.face_img) : props.widget.widgets_body.def_user_img_url}
                         alt=""/>
                    <div>
                        <p className="text-sm mr-3">
                            {showName ? props.widget.widgets_body.full_name : 'هویت تایید شده'}
                        </p>

                    </div>
                </div>
                <div className="flex flex-col">

                    <label htmlFor="image-input" className="bg-gray-100 text-sm bg-gray-100 px-3 py-1 rounded ">
                        تغییر تصویر
                        <input id="image-input" onChange={handleChooseFile} className="hidden" type="file"
                               accept="image/*"/>

                    </label>
                    {changedImage && <button onClick={() => setChangedImage(null)}
                                             className="text-sm py-1 px-3 bg-red-500 mt-2 rounded  text-white">حذف
                        تصویر</button>}
                </div>

            </div>
            <div className="flex border-t py-3 border-gray-100   justify-between items-center">
                <span className="text-sm">نمایش چهره رو آگهی</span>
                <Switch onColor="#36b570" onChange={(checked) => {
                    setShowImage(checked)


                }} dir="rtl" size={50} checkedIcon={false} uncheckedIcon={false} height={20} width={40}
                        checked={showImage}/>
            </div>
           {/* <div className="flex border-t py-3 border-gray-100 justify-between items-center">
                <span className="text-sm">نمایش نام رو آگهی</span>
                <Switch onColor="#36b570" onChange={(checked) => {
                    setShowName(checked)


                }} dir="rtl" size={50} checkedIcon={false} uncheckedIcon={false} height={20} width={40}
                        checked={showName}/>
            </div>*/}
            <div className="modal-buttons w-full mt-4  grid grid-cols-2 gap-2  ">
                <Button disabled={loading} onClick={handleCloseModal} rounded="rounded-xl"
                        theme="light">{props.confirmButtonText || 'بستن'}</Button>
                <Button loading={loading} onClick={handleConfirm} rounded="rounded-xl"
                        theme="green">{props.confirmButtonText || 'ذخیره'}</Button>
            </div>

        </div>

    </ModalWrapper>
}
export default EditAuthWidgetModal;